const theme = {
  // colors
  colors: {
    white: '#ffffff',
    purple: '#79589f'
  },
  // fonts
  fontWeights: {
    normal: '400',
    bold: '700'
  }
};

export default theme;
